import React from "react";
import { Layout, Row, Col } from "antd";
import HomeImg from "../../../assets/images/investors-page.png";
import { LANDING_PAGE_URL } from "../../../constant";
import "./layout.scss";

const { Header, Content } = Layout;

const MainLayout = (props) => {
  return (
    <Layout className="guest-layout">
      <Row>
        <Col span={10} className="guest-login-panel">
          <Header>
            <div className="logo logo-nav">
              <a
                href={LANDING_PAGE_URL}
                referrerPolicy="no-referrer"
                style={{ color: "rgba(0, 0, 0, 0.85)" }}
              >
                Conceptor
              </a>
            </div>
          </Header>
          <Content>
            {props.children}
          </Content>
        </Col>
        <Col
          span={14}
          style={{
            backgroundColor: "#D0BBFE",
            maxHeight: "100vh",
            minHeight: "100vh",
          }}
        >
          <div
            style={{
              position: "absolute",
              right: "0px",
              bottom: "0px",
              maxHeight: "75%",
              maxWidth: "90%",
            }}
          >
            <div
              style={{
                backgroundColor: "#DECFFF",
                borderRadius: "10px 0 0 0",
                paddingTop: "14px",
                paddingLeft: "14px",
              }}
            >
              <img src={HomeImg} width="140%" alt="" />
            </div>
          </div>
        </Col>
      </Row>
    </Layout>
  );
};

export default MainLayout;
